import { render, staticRenderFns } from "./TaskListComponent.vue?vue&type=template&id=46c9f4ff&scoped=true"
import script from "./TaskListComponent.vue?vue&type=script&lang=js"
export * from "./TaskListComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskListComponent.vue?vue&type=style&index=0&id=46c9f4ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c9f4ff",
  null
  
)

export default component.exports